export default __webpack_public_path__ + "assets/images/Payment_11.d49764.png";